import http from 'plugins/axios';

export default {
  getList() {
    return http.get({
      url: '/la/admin/league/list'
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/league/create',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/league/update',
      data
    });
  },
  remove(id) {
    return http.post({
      url: '/la/admin/league/remove',
      data: {
        id
      }
    });
  },
  close(leagueId) {
    return http.post({
      url: '/la/admin/league/close',
      data: {
        leagueId
      },
      dataType: 'form'
    });
  },
  setUnlock(data) {
    return http.post({
      url: '/la/admin/league/unlock/toggle',
      data,
      dataType: 'form'
    });
  },
  setLock(data) {
    return http.post({
      url: '/la/admin/league/lock/toggle',
      data,
      dataType: 'form'
    });
  },
  setConsider(data) {
    return http.post({
      url: '/la/admin/league/owner/consider',
      data,
      dataType: 'form'
    });
  },
  setOwnerChange(data) {
    return http.post({
      url: '/la/admin/league/owner/change',
      data,
      dataType: 'form'
    });
  },
  getConfig() {
    return http.get({
      url: '/la/admin/league/config/info'
    });
  },
  updateConfig(data) {
    return http.post({
      url: '/la/admin/league/config/update',
      data
    });
  }
};
